// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Components
import { Button } from "../button/Button";
import { Container } from "../container/Container";
import { HeaderFlyout } from "./flyout/HeaderFlyout";
import { HeaderOverlay } from "./overlay/HeaderOverlay";
import { Icon } from "../icon/Icon";
import { PrivacyPolicy } from "../privacy_policy/PrivacyPolicy";

import { Languages } from "./top/languages/Languages";
import { Regions } from "./top/regions/Regions";
// Enums
import { Language } from "../../../enums/Language";
// Models
import { User } from "../../../models/user/User";
// Interfaces
import { IRegion } from "../../../interfaces/IRegion";
import { ILanguage } from "../../../interfaces/ILanguage";
import { ICountry } from "../../../interfaces/ICountry";
import { ContentArea } from "../content_area/ContentArea";
import { Message } from "../message/Message";

@Component({
  name: "Header",
  components: {
    Button,
    Container,
    HeaderFlyout,
    HeaderOverlay,
    Icon,
    PrivacyPolicy,

    Languages,
    Regions,
    ContentArea,
    Message,
  },
  mixins: [template],
})
export class Header extends Vue {
  public get assetsUrl() {
    return APP_ASSETS_URL;
  }

  public activeOverlayInternal: string = "";
  public activeFlyoutInternal: string = "";
  public isMobileMenuOpenInternal: boolean = false;

  public isMobile: boolean = false;

  public prevScroll: number = 0;
  public isSticky: boolean = false;

  public privacyPolicyActiveTab = "anbieter";
  public isPrivacyPolicyVisible: boolean = false;

  public $el!: HTMLElement;

  @Prop({ default: true })
  public privacyPolicy!: boolean;

  @Prop({ default: true })
  public privacyPolicyIncluded!: boolean;

  @Prop({ default: "" })
  public privacyPolicyUrl!: string;

  @Prop()
  public privacyPolicyAnbieterUrl!: string;

  @Prop()
  public privacyPolicyRechtlicheHinweiseUrl!: string;

  @Prop()
  public privacyPolicyCookiesUrl!: string;

  @Prop()
  public privacyPolicyDatenschutzUrl!: string;

  @Prop({ default: null })
  public privacyPolicyLizenzhinweiseDritterUrl!: string | null;

  @Prop()
  public regions!: IRegion[];

  @Prop()
  public currentRegion!: string;

  @Prop()
  public languages!: ILanguage[];

  @Prop()
  public currentLanguage!: Language;

  @Prop({ type: [Object] })
  public authentication!: User;

  @Prop({ type: [Object], default: () => ({}) })
  public options!: object;

  @Prop({ default: "" })
  public activeOverlay!: string;

  @Prop({ default: "" })
  public activeFlyout!: string;

  @Prop({ default: false })
  public isMobileMenuOpen!: boolean;

  @Prop({ type: [Object] })
  public brandmarkTo!: any;

  @Prop({ default: "#" })
  public brandmarkHref!: string;

  @Prop({ default: false })
  public showHeaderManually!: boolean;

  @Prop({ default: false })
  public showMobileMenuManually!: boolean;

  @Watch("activeOverlay")
  public watchActiveOverlay(activeOverlay, oldActiveOverlay) {
    if (activeOverlay != this.activeOverlayInternal) {
      this.activeOverlayInternal = activeOverlay;
    }
  }

  @Watch("isMobileMenuOpen")
  public watchIsMobileMenuOpen(isMobileMenuOpen, oldIsMobileMenuOpen) {
    if (isMobileMenuOpen != this.isMobileMenuOpenInternal) {
      this.isMobileMenuOpenInternal = isMobileMenuOpen;

      if (this.isMobileMenuOpenInternal) {
        document.body.classList.add(`${this.$appPrefix}-mobile-menu--open`);
      } else {
        document.body.classList.remove(`${this.$appPrefix}-mobile-menu--open`);
      }
    }
  }

  @Watch("activeFlyout")
  public watchActiveFlyout(activeFlyout, oldActiveFlyout) {
    if (activeFlyout != this.activeFlyoutInternal) {
      if (activeFlyout != "") this.handleActivateFlyout(activeFlyout);
      else this.handleCloseFlyout();
    }
  }

  @Watch("showHeaderManually")
  public watchShowHeaderManually(showHeaderManually, oldshowHeaderManually) {
    if (showHeaderManually) {
      this.showHeader(this.showMobileMenuManually);
    }
  }

  public created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.setIsMobile);
  }

  public mounted() {
    this.prevScroll = window.pageYOffset || document.documentElement!.scrollTop;

    this.activeOverlayInternal = this.activeOverlay;
    this.activeFlyoutInternal = this.activeFlyout;
    this.isMobileMenuOpenInternal = this.isMobileMenuOpen;
    this.setIsMobile();
  }

  public destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.setIsMobile);
  }

  public showHeader(openMobileMenu) {
    const headerHeight = this.$el.offsetHeight;

    this.isSticky = true;
    this.changeBodyPadding(headerHeight);

    if (openMobileMenu && this.isMobile) {
      this.isMobileMenuOpenInternal = true;
      this.$emit("update:isMobileMenuOpen", true);
      document.body.classList.add(`${this.$appPrefix}-mobile-menu--open`);
    }
  }

  public handleScroll(e) {
    const currentScroll = window.pageYOffset || document.documentElement!.scrollTop;
    const headerHeight = this.$el.offsetHeight;

    if (currentScroll > this.prevScroll) {
      if (!this.isSticky) {
        this.prevScroll = currentScroll;
      } else if (currentScroll > this.prevScroll + 10) {
        if (this.activeOverlayInternal != "" || this.isMobileMenuOpenInternal) return;

        this.isSticky = false;
        this.$el.style.top = "";

        this.changeBodyPadding(0);
      }
    } else {
      if (this.isSticky) {
        this.prevScroll = currentScroll;
      }

      if (currentScroll < this.prevScroll - 10 && currentScroll > headerHeight) {
        this.isSticky = true;
        this.changeBodyPadding(headerHeight);
      } else if (currentScroll == 0) {
        if (this.activeOverlayInternal != "" || this.isMobileMenuOpenInternal) return;

        this.isSticky = false;
        this.$el.style.top = "";
        this.changeBodyPadding(0);
      } else {
        this.$el.style.top = "";
      }
    }
  }

  public handleActivateOverlay(id: any, e: Event, isLink: boolean) {
    if (isLink) return;

    if (e) e.preventDefault();

    if (id != this.activeOverlayInternal) {
      this.isSticky = true;

      const headerHeight = this.$el.offsetHeight;
      this.changeBodyPadding(headerHeight);

      this.activeOverlayInternal = id;
      this.$emit("update:activeOverlay", id);
    } else {
      this.handleCloseOverlay();
    }
  }

  public handleCloseOverlay() {
    const currentScroll = window.pageYOffset || document.documentElement!.scrollTop;

    if (currentScroll == 0) {
      this.isSticky = false;
      this.$el.style.top = "";
      this.changeBodyPadding(0);
    }

    this.activeOverlayInternal = "";
    this.$emit("update:activeOverlay", "");
  }

  public handleToggleMobileMenu() {
    if (this.isMobileMenuOpenInternal) {
      this.isMobileMenuOpenInternal = false;
      this.$emit("update:isMobileMenuOpen", false);
      document.body.classList.remove(`${this.$appPrefix}-mobile-menu--open`);
    } else {
      this.isMobileMenuOpenInternal = true;
      this.$emit("update:isMobileMenuOpen", true);
      document.body.classList.add(`${this.$appPrefix}-mobile-menu--open`);
    }
  }

  private handleCountrySelect(country: ICountry) {
    this.$emit("change-country", country);
  }

  public handleLanguageSelect(language: Language) {
    this.$emit("change-language", language);
  }

  public handlePrivacyPolicyClick(e: Event) {
    if (this.privacyPolicyIncluded) {
      this.isPrivacyPolicyVisible = !this.isPrivacyPolicyVisible;
    }

    this.$emit("top-item-click", "privacy-policy");
  }

  public setIsMobile() {
    const width = window.innerWidth || (<any>document).documentElement.clientWidth || (<any>document).body.clientWidth;

    if (width < 768) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
      this.activeOverlayInternal = this.activeOverlay;
      this.$emit("update:activeOverlay", this.activeOverlayInternal);
      this.isMobileMenuOpenInternal = false;
      this.$emit("update:isMobileMenuOpen", false);
      document.body.classList.remove(`${this.$appPrefix}-mobile-menu--open`);
    }
  }

  private changeBodyPadding(padding) {
    if (padding == 0) {
      document.body.style.paddingTop = "";
    } else {
      document.body.style.paddingTop = padding + "px";
    }
    this.$emit("body-padding-changed", padding);
  }

  public handleActivateFlyout(id: any) {
    if (id != this.activeFlyoutInternal) {
      document.body.classList.add(`${this.$appPrefix}-flyout--open`);

      if (this.isMobile) this.isSticky = true;

      this.activeFlyoutInternal = id;
      this.$emit("update:activeFlyout", id);
    } else {
      this.handleCloseFlyout();
    }
  }

  public handleCloseFlyout() {
    document.body.classList.remove(`${this.$appPrefix}-flyout--open`);
    this.activeFlyoutInternal = "";
    this.$emit("update:activeFlyout", "");
  }
}
